// src/seo/SEO.js
import React from 'react';
import { SEO_CONFIG } from './SEOConfig';

export default function SEO({
    title,
    description,
    keywords,
    image,
    url,
    schema
}) {
    // 1. Setup Defaults (if props are missing, use Config)
    const siteTitle = title
        ? `${title} | ${SEO_CONFIG.orgNameMalayalam}`
        : SEO_CONFIG.defaultTitle;

    const metaDescription = description || SEO_CONFIG.defaultDescription;
    const metaImage = image || SEO_CONFIG.baseSchema.logo;
    const metaUrl = url || SEO_CONFIG.baseUrl;
    const canonical = url || SEO_CONFIG.baseUrl;

    return (
        <>
            {/* Standard SEO */}
            <title>{siteTitle}</title>
            <meta name="description" content={metaDescription} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={canonical} />

            {/* Open Graph / Facebook / WhatsApp */}
            <meta property="og:title" content={title || SEO_CONFIG.orgName} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={metaUrl} />
            <meta property="og:image" content={metaImage} />

            {/* Structured Data (JSON-LD) */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </>
    );
}